export default __webpack_public_path__ + "static/media/Appointments@3x.a827c2ff.png";